import { Link } from 'gatsby'
import styled from 'styled-components'
import { ThemeModes } from 'theme/theme'

export const MenuIconWrapper = styled.button`
    background: none;
    border: none;
    cursor: pointer;

    svg {
        color: ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST
                ? theme?.highContrast?.primary
                : theme.black};

        width: 20px;
        height: 20px;
    }
`

export const CloseIconWrapper = styled(MenuIconWrapper)`
    position: absolute;
    top: 30px;
    right: 50px;
`

export const NavBar = styled.nav`
    width: 100%;
    min-height: 50px;
    background-color: ${({ theme }) =>
        theme.mode === ThemeModes.HIGH_CONTRAST
            ? theme.highContrast.colorBgBase
            : theme.colorBgBase};
    border-bottom: 1px solid
        ${({ theme }) =>
            theme.mode === ThemeModes.HIGH_CONTRAST
                ? theme?.highContrast?.secondary
                : theme.gray};
    padding-top: 24px;
    padding-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 30px;
`

export const LinksList = styled.ul`
    list-style: none;
    display: flex;
    gap: 15px;
    margin-right: 12px;
    > li {
        text-align: center;
        display: flex;
        align-items: center;
    }
`

export const NavLink = styled(Link)`
    color: ${({ theme }) =>
        theme.mode === ThemeModes.HIGH_CONTRAST
            ? theme.highContrast.primary
            : theme.black};
    font-size: ${({ theme }) => theme.fontSize.m};
    text-decoration: none !important;

    &:hover {
        color: inherit;
    }
`

export const InnerWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;

    .hidden {
        display: none;
    }

    @media only screen and (max-width: 510px) {
        gap: 18px;
    }
`

export const SideNav = styled.div`
    position: fixed;
    display: none;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    background-color: ${({ theme }) =>
        theme.mode === ThemeModes.HIGH_CONTRAST
            ? theme.highContrast.colorBgElevated
            : theme.white};
    padding: 50px;
    z-index: 10;

    &.visible {
        display: block;
    }
`

export const BurgerLinksList = styled.ul`
    list-style: none;
    display: flex;
    gap: 18px;
    flex-direction: column;
    padding-top: 30px;
`

export const FlexWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 120px;
    max-width: 60%;
    margin-top: -25px;
`

export const StyledList = styled.ul`
    list-style-type: none;
    display: flex;
    gap: 10px;
`

export const StyledLogo = styled.img`
    height: 51px;
`
